export type PartialFailureDetail = {
  failing_step: string;
  cause: string;
  landed: Array<{
    entityType: string;
    platform_entity_id: string;
    mode: 'create' | 'existing';
  }>;
};

export function extractPartialFailureDetail(error: unknown): PartialFailureDetail | null {
  if (!error || typeof error !== 'object') return null;
  const data = (error as { data?: unknown }).data;
  if (!data || typeof data !== 'object') return null;
  const pf = (data as { partial_failure?: unknown }).partial_failure;
  if (!pf || typeof pf !== 'object') return null;
  const candidate = pf as Record<string, unknown>;
  if (typeof candidate.failing_step !== 'string') return null;
  if (typeof candidate.cause !== 'string') return null;
  if (!Array.isArray(candidate.landed)) return null;
  return {
    failing_step: candidate.failing_step,
    cause: candidate.cause,
    landed: candidate.landed as PartialFailureDetail['landed']
  };
}

export function formatPartialFailureMessage(detail: PartialFailureDetail): string {
  const landedList =
    detail.landed.length === 0 ? 'none' : detail.landed.map(e => e.entityType).join(', ');
  return `Partial failure at step "${detail.failing_step}": ${detail.cause}. Landed: ${landedList}.`;
}
